import { Fab } from "@mui/material";

interface ClearButtonProps {
  click: () => void;
}

export const CopyButton = ({ click }: ClearButtonProps) => {
  return (
    <Fab
      variant="extended"
      color="primary"
      sx={{ fontWeight: "600", color: "white" }}
      onClick={click}
    >
      Copy
    </Fab>
  );
};
